import React from 'react';
import SeoWrapper from '../components/SeoWrapper';
import About from '../components/About';
import Certifications from '../components/Certifications';
import content from '../data/content.json';

const AboutPage = ({ language, years }) => {
  return (
    <>
      <SeoWrapper
        title={language === 'pl' ? "O mnie" : "About Me"}
        description={language === 'pl' ? content.about.description_pl.substring(0, 150) : content.about.description_en.substring(0, 150)}
        url="/o-mnie"
      />
      <div className="pt-20">
        <About about={content.about} years={years} language={language} />
        <Certifications certifications={content.certifications} language={language} />
      </div>
    </>
  );
};

export default AboutPage;
